import { Link } from '@remix-run/react';
import { AlertTriangle, ShieldAlert } from 'lucide-react';
import InstaIcon from '~/assets/icons/InstaIcon';

import { useRootLoader } from '~/utils/use-root-loader';

export default function Footer() {
  const rootData = useRootLoader();
  const pages = rootData?.pages ?? [];
  const collections = rootData?.collections ?? [];

  return (
    <section className="bg-white text-black pt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-28">
        <div className="lg:col-span-2">
          <h3 className="text-xl font-semibold mb-4">About KTM Vape</h3>{' '}
          <p className="text-gray-600 text-sm leading-relaxed">
            KTM Vape is your trusted destination for premium vaping products. We
            offer a carefully selected range of vape devices, disposable vapes,
            pods, e-liquids, and accessories from reliable brands. Our mission is
            to provide quality products, competitive pricing, and exceptional
            customer service.
          </p>
        </div>

        <div className="lg:col-span-1">
          <h3 className="text-xl font-semibold mb-4">Shop</h3>{' '}
          <ul className="space-y-2  text-sm">
            {collections.map((collection) => (
              <li key={collection.id}>
                <Link
                  to={`/collections/${collection.slug}`}
                  className="text-gray-600 hover:text-black transition-colors duration-200"
                >
                  {collection.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-1">
          {' '}
          <h3 className="text-xl font-semibold mb-4">Information</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/contact"
                className="text-gray-600 hover:text-black transition-colors duration-200"
              >
                Contact Us
              </Link>
            </li>
            <li>
              <Link
                to="/faq"
                className="text-gray-600 hover:text-black transition-colors duration-200"
              >
                FAQ
              </Link>
            </li>

            {pages.map((page) => (
              <li key={page.id}>
                <Link
                  to={`/pages/${page.slug}`}
                  className="text-gray-600 hover:text-black transition-colors duration-200"
                >
                  {page.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-xl font-semibold mb-4">Contact</h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li>Business Hours: Monday–Sunday, 9:00 AM–10:00 PM</li>
            <li>Email: support@ktmvape.com</li>
            <li>
              <Link to="#" className="hover:underline flex items-center gap-2">
                <InstaIcon className="text-black" /> Follow Us
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Compliance / disclaimer band */}
      <div className="mt-10 border-t border-gray-200 bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-6 md:flex-row md:items-start">
            <div className="flex-shrink-0">
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
                <ShieldAlert className="h-7 w-7" />
              </div>
            </div>
            <div className="grid gap-6 text-sm text-gray-600 sm:grid-cols-2">
              <div>
                <h4 className="mb-1.5 flex items-center gap-2 font-semibold text-gray-900">
                  <AlertTriangle className="h-4 w-4 flex-shrink-0 text-primary" />
                  Age Restriction
                </h4>
                <p className="leading-relaxed">
                  Products sold by KTM Vape are intended only for adults of legal
                  smoking age in their jurisdiction. Keep all vaping products out
                  of reach of children and pets.
                </p>
              </div>
              <div>
                <h4 className="mb-1.5 flex items-center gap-2 font-semibold text-gray-900">
                  <AlertTriangle className="h-4 w-4 flex-shrink-0 text-primary" />
                  Product Disclaimer
                </h4>
                <p className="leading-relaxed">
                  These products are intended for adult smokers and vapers only.
                  Nicotine is an addictive substance. Please use responsibly and
                  follow all applicable local laws and regulations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-sm text-gray-500 sm:flex-row sm:px-6 lg:px-8">
          <p>© 2026 KTM Vape. All Rights Reserved.</p>
          <p className="text-xs text-gray-400">Please vape responsibly.</p>
        </div>
      </div>
    </section>
  );
}
